﻿/**
* DevExpress Analytics (query-builder\elements\querySurface.js)
* Version:  21.2.7
* Build date: Apr 13, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ko = require("knockout");
var baseSurface_1 = require("../../core/elements/baseSurface");
var _arrayutils_1 = require("../../core/utils/_arrayutils");
var localization_utils_1 = require("../../property-grid/localization/localization_utils");
var _hoverInfo_1 = require("../../core/internal/_hoverInfo");
var QuerySurface = (function (_super) {
    __extends(QuerySurface, _super);
    function QuerySurface(query, zoom) {
        if (zoom === void 0) { zoom = ko.observable(1); }
        var _this = _super.call(this, query, {
            measureUnit: ko.observable('Pixels'),
            zoom: zoom,
            dpi: ko.observable(100)
        }, QuerySurface._unitProperties) || this;
        _this.placeholder = function () { return localization_utils_1.getLocalization('Drop a table or view here to create a query.', 'AnalyticsCoreStringId.QueryBuilder_SurfacePlaceholder'); };
        _this.tables = ko.observableArray();
        _this.relations = ko.observableArray();
        _this.allowMultiselect = false;
        _this.focused = ko.observable(false);
        _this.selected = ko.observable(false);
        _this.underCursor = ko.observable(new _hoverInfo_1.HoverInfo());
        _this.templateName = 'dx-query-surface';
        _this.rtl = ko.observable(false);
        _this.measureUnit = _this._context.measureUnit;
        _this.dpi = _this._context.dpi;
        _this._context = _this;
        _this.margins = { bottom: _this['_bottom'], left: _this['_left'], right: _this['_right'], top: _this['_top'] };
        _this.zoom = zoom;
        _arrayutils_1.createObservableArrayMapCollection(query.tables, _this.tables, _this._createSurface);
        _arrayutils_1.createObservableArrayMapCollection(query.relations, _this.relations, _this._createSurface);
        _this._joinedColumns = ko.computed(function () {
            var resultColumns = [];
            _this.relations().forEach(function (relation) {
                relation.conditions().forEach(function (condition) {
                    var joinModel = condition.getControlModel();
                    joinModel.parentColumn() && resultColumns.push(joinModel.parentColumn());
                    joinModel.nestedColumn() && resultColumns.push(joinModel.nestedColumn());
                });
            });
            return resultColumns;
        });
        return _this;
    }
    QuerySurface.prototype.checkParent = function (surfaceParent) { return false; };
    QuerySurface.prototype.getChildrenCollection = function () {
        return this.tables;
    };
    QuerySurface.prototype.isJoined = function (column) {
        return this._joinedColumns().indexOf(column.getControlModel()) > -1;
    };
    QuerySurface._unitProperties = {
        _width: function (o) { return o.pageWidth; },
        _height: function (o) { return o.pageWidth; },
        pageWidth: function (o) { return o.pageWidth; },
        pageHeight: function (o) { return o.pageHeight; },
        _bottom: function (o) { return o.margins.bottom; },
        _left: function (o) { return o.margins.left; },
        _right: function (o) { return o.margins.right; },
        _top: function (o) { return o.margins.top; }
    };
    return QuerySurface;
}(baseSurface_1.SurfaceElementBase));
exports.QuerySurface = QuerySurface;
